import { render } from "./MvNtfc.vue?vue&type=template&id=ac57d8dc&ts=true"
import script from "./MvNtfc.vue?vue&type=script&lang=ts"
export * from "./MvNtfc.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__